import {LEAF_TYPE_TO_ICON} from 'data-types/benchling-type-def/leafTypeToIcon';
import {FIELD_TYPE_TO_LEAF_TYPE, SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

/**
 * Return the icon for the output Result Schema field
 *
 * Internally, this takes the simple implementation of mapping the field's type to a Benchling Type Def, then
 * to an icon. This matches how we get the icon for the input Data Frame column. See `columnToTypeIcon`, which
 * maps the column's Benchling Type Def to an icon).
 *
 * The alternative is to call `getIconAndLabel`, but that currently requires more machinery to use: (1) query
 * for [or fake] `SchemaFieldSelector` objects, for the `schemaFieldSelectors` arg, and (2) specify [or fake]
 * a base URL, for the `ownerUrlId` arg. That is what `BaseSubdependencyList` does. It does yield more
 * accurate icons (for example, it will use the user-configured icon for an Entity Schema link field), but it
 * (1) makes assumptions about `getIconAndLabel`'s internal implementation and (2) diverges from the input
 * Data Frame.
 */
export default function getFieldIcon(field: SchemaField): BenchlingIconName {
  return LEAF_TYPE_TO_ICON[FIELD_TYPE_TO_LEAF_TYPE[field.fieldType]];
}
